/*
* Product tile Quick ATC form CSS
* Date: 5th-June-24
* AB Test: TR108
*/

document.addEventListener("DOMContentLoaded", function() {
  var wrappers = document.querySelectorAll(".tr108-quick-atc-wrapper");
  if (wrappers.length) {
    wrappers.forEach(function(wrapper) {
      wrapper.addEventListener("mouseleave", function() {
        this.querySelector("form").parentElement.classList.remove("show-options");
      })
    })
    
    // input click action
    var forms = document.querySelectorAll(".tr108-quick-atc-container form");
    forms.forEach(function(form) {
      var inputs = form.querySelectorAll('input[type="radio"]');
      inputs.forEach(function(input) {
        input.addEventListener("click", function(e) {
          e.preventDefault();
          var hasMultipleOptions = this.hasAttribute("data-multiple-options");
          this.parentElement.querySelectorAll("input").forEach(function(input) {
            input.removeAttribute("checked");
          })
          this.setAttribute("checked", "checked");
  
          console.log('>> this', this)
  
          var optionLabel = this.parentElement.parentElement.querySelector("[data-tr108-selected-option-value]");
          optionLabel.innerHTML = this.value;
  
          updateVariantId(hasMultipleOptions, form, inputs);
        })
      })
  
      form.addEventListener("submit", function(e) {
        e.preventDefault();
        handleFormSubmit(this);
      })
    })
  
    // update select element
    function updateVariantId(hasMultipleOptions, form, inputs) {
      var select = form.querySelector("select");
      var selectedInputs = [];
      inputs.forEach(function(input) {
        if (input.hasAttribute("checked")) {
          selectedInputs.push(input.value)
        }
      })
  
      var selectedTitle = selectedInputs.join(" / ");
      var matchingOption = select.querySelector('option[data-value="'+selectedTitle+'"]');
      if (matchingOption) {
        matchingOption.selected = true;
      }
  
      if (!hasMultipleOptions) {
        addToCart(form);
      }
    }
  
    // on submit form handler
    function handleFormSubmit(form) {
      var isSingleVariant = form.querySelector("[data-tr108-quick-add]").hasAttribute("data-single-variant");
      
      if (isSingleVariant) {
        addToCart(form);
      } else {
        if (form.parentElement.classList.contains("multiple-options") && form.parentElement.classList.contains("show-options")) {
          addToCart(form);
        }
        form.parentElement.classList.add("show-options");
      }
    }
  
    // add products to the cart
    function addToCart(form) {
      form.querySelector(".loader").classList.remove("disable");
      var formData = new FormData(form);
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        return response.json();
      })
      .then(data => {
        loadAjaxCart(form);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  
    // open sidecart and populate data
    function loadAjaxCart(form) {
      fetch("/cart?view=ajax", {
        method: "GET",
        headers: {
          "Content-Type": "application/Html",
        },
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.text();
      })
      .then((cartData) => {
        var update_cart_content = document.querySelector(".cart-item__wrapper");
        update_cart_content.innerHTML = cartData;
        var header_cart_quantitys = document.querySelectorAll("[data-cart-item-count]");
        var cart_item_count = update_cart_content.querySelector(".cart-item__extra_info").dataset.item_count;
        var cart_total_price = update_cart_content.querySelector(".cart-item__extra_info").dataset.total_price;
        document.querySelector(".cart_item-count").innerHTML = cart_item_count;
        document.querySelector(".cart_item-total-price").innerHTML = cart_total_price;
        header_cart_quantitys.forEach(function (header_cart_quantity) {
          header_cart_quantity.innerHTML = cart_item_count.split(" ")[0];
          header_cart_quantity.dataset.cartItemCount = cart_item_count.split(" ")[0];
        });
        document.querySelector(".header_click-event").click();
        document.querySelector(".cart_checkout-button").classList.remove("d-none");
  
        form.querySelector(".loader").classList.add("disable");
      })
      .catch((error) => {
        console.log("Error:", error);
        form.querySelector(".loader").classList.add("disable");
      });
    }
  }
})
